import {
  notifyError,
  useNotifications,
  notifySuccess,
} from 'Logic/Notifications.js'
import { useMutation } from 'Data/Api.js'
import { useSetFlowTo, normalizePath } from 'Simple/Flow.js'
import mutation from './mutation.graphql.js'
import mutationUpdateResource from './mutation-update-resource.graphql.js'

/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props, data) {
  let [, notify] = useNotifications()

  let [, executeMutationUpdateResource] = useMutation(mutationUpdateResource)
  let [, executeMutation] = useMutation(mutation)
  let setFlowTo = useSetFlowTo(props.viewPath)

  return async function onSubmit({ args, value }) {
    switch (args.type) {
      case 'generate_letter': {
        let mutationResponse = await executeMutation({
          patient_id: value.patient._id,
          document_template_id: value.resources[0].resource_id,
          recipient_id: value.resources[0].metadata?.recipient_id,
          postal_address_id: value.resources[0].metadata?.postal_address_id,
        })

        if (mutationResponse.error) {
          notify(notifyError('Error while generating letter.'))
          return
        }

        await executeMutationUpdateResource({
          resource_id: value.resources[0].id,
          document_id:
            mutationResponse.data.tasks_generate_letter.documentNodeId,
        })

        notify(notifySuccess(`Letter generated.`))
        setFlowTo(normalizePath(props.viewPath, 'Content/Letter/Content'))
        break
      }
      default:
    }
  }
}
